/* ==========================================================================
   DBR HIGH PERFORMANCE — v4.0 layer · customer gallery
   Built by Project 215 (https://www.project215.com)
   "Show more" + lightbox (keyboard, swipe). Fail-open: without JS every
   photo is visible and nothing is hidden behind .js gating.
   ========================================================================== */
(function () {
  'use strict';

  function initGallery(root) {
    (root || document).querySelectorAll('[data-cgal]').forEach(function (sec) {
      if (sec.__dbrCgal) return;
      sec.__dbrCgal = true;

      var items = Array.prototype.slice.call(sec.querySelectorAll('.dbr-cgal__item'));
      var more = sec.querySelector('[data-cgal-more]');
      if (more) {
        more.addEventListener('click', function () {
          items.forEach(function (it) { it.classList.remove('is-more'); });
          more.hidden = true;
        });
      }

      var lb = sec.querySelector('[data-cgal-lb]');
      if (!lb || !items.length) return;
      var img = lb.querySelector('[data-cgal-img]');
      var cap = lb.querySelector('[data-cgal-cap]');
      var cnt = lb.querySelector('[data-cgal-count]');
      var closeBtn = lb.querySelector('[data-cgal-close]');
      var cur = 0;
      var last = null;
      var touchX = null;

      function show(i) {
        cur = (i + items.length) % items.length;
        var b = items[cur].querySelector('[data-cgal-open]');
        if (!b) return;
        img.src = b.getAttribute('data-full') || '';
        img.alt = b.getAttribute('data-alt') || '';
        var c = b.getAttribute('data-cap') || '';
        cap.textContent = c;
        cap.hidden = !c;
        cnt.textContent = (cur + 1) + ' / ' + items.length;
      }

      function open(i) {
        last = document.activeElement;
        show(i);
        if (typeof lb.showModal === 'function') lb.showModal();
        else lb.setAttribute('open', '');
        document.documentElement.classList.add('dbr-lb-open');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        if (typeof lb.close === 'function') lb.close();
        else { lb.removeAttribute('open'); onClosed(); }
      }

      function onClosed() {
        document.documentElement.classList.remove('dbr-lb-open');
        img.removeAttribute('src');
        if (last && typeof last.focus === 'function') last.focus();
      }

      lb.addEventListener('close', onClosed);
      items.forEach(function (it, i) {
        var b = it.querySelector('[data-cgal-open]');
        if (b) b.addEventListener('click', function () { open(i); });
      });
      lb.querySelector('[data-cgal-prev]').addEventListener('click', function () { show(cur - 1); });
      lb.querySelector('[data-cgal-next]').addEventListener('click', function () { show(cur + 1); });
      if (closeBtn) closeBtn.addEventListener('click', close);
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(cur - 1);
        if (e.key === 'ArrowRight') show(cur + 1);
      });
      lb.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 40) show(dx < 0 ? cur + 1 : cur - 1);
      }, { passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initGallery(); });
  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target); });
  /* Theme editor: selecting a photo that sits behind "Show more" reveals the set. */
  document.addEventListener('shopify:block:select', function (e) {
    var it = e.target && e.target.closest ? e.target.closest('.dbr-cgal__item') : null;
    if (!it || !it.parentNode) return;
    it.parentNode.querySelectorAll('.is-more').forEach(function (x) { x.classList.remove('is-more'); });
  });
})();
